import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-expand-row',
  templateUrl: './ag-expand-row.component.html',
  styleUrls: ['./ag-expand-row.component.css']
})
export class AgExpandRowComponent implements OnInit, ICellRendererAngularComp {

  params: any;
  count = 0;
  constructor() { }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;
    this.count = params.rowIndex + 1;
  }

  refresh(): boolean {
    return true;
  }

  expandRow(newStatus: boolean) {
    this.params.data.expanded = newStatus;
    this.params.context.componentParent.expandRow(this.params.data, this.params.rowIndex);
  }

}
